import { render, staticRenderFns } from "./SettingsRegionSection.vue?vue&type=template&id=1a0d2110&scoped=true"
import script from "./SettingsRegionSection.vue?vue&type=script&lang=js"
export * from "./SettingsRegionSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsRegionSection.vue?vue&type=style&index=0&id=1a0d2110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0d2110",
  null
  
)

export default component.exports